// This component loads a font, and emits a CSS style object, to be applied
// to the element(s) that wants a custom font.
// The usage is a bit awkward tbh, is there a better way?

import PQueue from 'p-queue'

import { loadFontAndGetFontStyle, getStoredFont } from '@/font-loader/font-loader-utils'

const debug = require('debug')('sbox:font')

export default {
    name: 'FontLoader',
    render: () => null,
    props: {
        fontConfig: Object,
        styleObj: Object,
    },
    watch: {
        // Once the real fontUrl value is fetched from the server, overwrite
        // whatever was set by the localStorage fontUrl.
        fontConfig: {
            handler: 'queueUpdateStyle',
            deep: true,
            immediate: true
        },
        // Optimization: Store fontUrl in localStorage for faster font loads.
        'fontConfig.channelId': {
            handler: function (channelId) {
                if (!channelId) { return }

                const fontUrl = getStoredFont(this.fontConfig.fontKey)
                if (fontUrl) {
                    debug(`Found fontUrl in localStorage: ${fontUrl}`)
                    const fontConfig = { ...this.fontConfig, fontUrl }
                    this.queueUpdateStyle(fontConfig)
                }
            },
            immediate: true
        },
    },
    beforeCreate () {
        this.queue = new PQueue({ concurrency: 1 })
    },
    methods: {
        // fontConfig can rapidly change, and have a mix of truthy/falsy
        // fontUrls. Truthy urls take time to load, while falsy urls fail
        // immediately. To deterministically load the correct font, put all
        // calls into a queue.
        async queueUpdateStyle (fontConfig) {
            this.queue.add(() => this.updateStyle(fontConfig))
        },
        async updateStyle (fontConfig) {
            if (!fontConfig.channelId) { return }

            const styleObj = await loadFontAndGetFontStyle(fontConfig)
            this.$emit('update:styleObj', styleObj)
        }
    }
}
